// extracted by mini-css-extract-plugin
export default {"points-wrapper":"Points_points-wrapper__7iGRc","points":"Points_points__cvnaH"};